export const loginType = {
    'Facebook' : '페이스북',
    'Kakao' : '카카오톡',
    'Google' : '구글',
    'Apple' : '애플',
}
